import { Typography, useTheme, Grid, Box } from '@mui/material';

import { useCallback, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { ActionButton } from '../buttons/ActionButton';
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/macro';

export const userPdfDropZoneStyles = (theme) => {
    return {
        userPdfDropzoneBase: {
            padding: '40px',
            borderWidth: 2,
            borderRadius: 2,
            borderColor: 'lightgrey',
            borderStyle: 'dashed',

            color: theme.palette.primary.dark,
            outline: 'none',
            transition: 'border .24s ease-in-out',
            width: '100%',
            textAlign:'center'
        },
        userPdfDropzoneActive: { borderColor: theme.palette.primary.dark },
        userPdfDropzoneFocused: { borderColor: theme.palette.secondary.dark },
        userPdfDropzoneAccepted: { borderColor: theme.palette.success.dark },
        userPdfDropzoneRejected: { borderColor: theme.palette.error.dark }
    };
};

const UploadDropzone = ({ selectedFile, setSelectedFile, uploadAction,disabled }) => {
    const theme = useTheme();
    const {_} = useLingui()

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            setSelectedFile(file);
            // const reader = new FileReader();
            // reader.onabort = () => setUploadMessage('La lettura del file è stata interrotta.');
            // reader.onerror = () => setUploadMessage('La lettura del file è fallita.');
            // reader.onload = () => {
            //     console.log('on load');
            //   // Do whatever you want with the file contents
            //   const binaryStr = reader.result;
            //   // const base64Position = binaryStr.indexOf('base64,');
            //   // const base64Length = 'base64,'.length;
            //   // const dataType = binaryStr.substring(0, base64Position + base64Length);
            //   // const selFile = binaryStr.replace(dataType, '');
            //   setFileContent(binaryStr);
            // };
            // setSelectedFileName(file.path);
            // reader.readAsDataURL(file);
        });
    }, []);

    const { getRootProps, getInputProps, isDragActive, isFocused, isDragAccept, isDragReject } = useDropzone({
        accept: {
            'video/mp4': []
        },
        // maxSize: 1041855583, // 100 mb
        multiple: false,
        onDrop
    });

    const dropZoneStyles = userPdfDropZoneStyles(theme);

    const style = useMemo(
        () => ({
            ...dropZoneStyles.userPdfDropzoneBase,
            ...(isDragActive ? dropZoneStyles.userPdfDropzoneActive : {}),
            ...(isFocused ? dropZoneStyles.userPdfDropzoneFocused : {}),
            ...(isDragAccept ? dropZoneStyles.userPdfDropzoneAccepted : {}),
            ...(isDragReject ? dropZoneStyles.userPdfDropzoneRejected : {})
        }),
        [dropZoneStyles, isDragActive, isFocused, isDragAccept, isDragReject]
    );

    const resetUpload = () => {
        //reset
        setSelectedFile(null);
    };

    return (
        <Box sx={{width: '100%',display: 'flex',flexDirection: 'column',gap:1}} justifyContent={'center'} alignItems={'center'}>
            <Box sx={{width: '100%', flex: 1,display: 'flex',flexGrow:1}}>
                {selectedFile ? (
                    <Box sx={{display: 'flex',flexDirection:'column'}}>
                    <Typography variant='h4'> {_(msg`Nome file`)}</Typography>
                    <Typography variant='h4'>{selectedFile.name}</Typography>
                    </Box>
                ) : (
                    <div {...getRootProps({ style })}>
                        <input {...getInputProps()} />
                        {isDragActive ? (
                            <Typography component={'p'}>{_(msg`Trascina il file qui ...`)}</Typography>
                        ) : (
                            <Typography component={'p'}> {_(msg`Trascina il file qui, o fai click per selezionare un
                                file`)}</Typography>
                        )}
                    </div>
                )}
            </Box>
            <Box sx={{width: '100%', flex: 1,display: 'flex',flexGrow:1}}>
                <ActionButton
                    color="primary"
                    variant="contained"
                    action={() => uploadAction(false)}
                    disabled={!selectedFile || disabled}
                    icon={'upload'}
                    iconSize={'small'}
                    label={_(msg`Upload`)}
                    size={'small'}
                    tooltip={_(msg`Upload`)}
                    fullWidth
                />
            </Box>
            <Box sx={{width: '100%', flex: 1,display: 'flex',flexGrow:1}}>
                <ActionButton
                    color="primary"
                    variant="contained"
                    action={resetUpload}
                    disabled={!selectedFile}
                    icon={'cancel'}
                    iconSize={'small'}
                    label={_(msg`Reset file`)}
                    size={'small'}
                    tooltip={_(msg`Reset file`)}
                    fullWidth
                />
            </Box>
        </Box>
    );
};

export default UploadDropzone;
